<template>
    <div class="house-filter" :class="{ open: openState}" v-bind:style="{'top': filterTop}">
        <div class="house-filter-wrap" v-bind:style="{'min-height': myHeight}">
            <div class="filter-title">
                <img src="../../../../assets/img/icon/filter_gray.svg" alt="">
                篩選
                <span v-show="filterState" class="clear-filter" @click="setFilterDefault">
                    清除篩選
                </span>
            </div>
            <div class="default location">
                <div class="title level1-title-font">地點</div>
                <div class="group">
                    <rent-select class="select-scroll" refName="county" :selectMsg="address.county.msg" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="filterCountyIsEmpty">
                        <ul>
                            <li :data-id="index" :data-name="county" v-for="(county, index) in countyResult" :key="index">
                                {{county}}
                            </li>
                        </ul>
                    </rent-select>
                    <rent-select class="select-scroll" refName="district" :selectMsg="address.district.msg" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="filterDistrictIsEmpty">
                        <ul v-if="houseFilter.countyId">
                            <li :data-id="index" :data-name="district.districtName" v-for="(district, index) in districtsResult" :key="index">
                                {{district.districtName}}
                            </li>
                        </ul>
                    </rent-select>
                </div>
            </div>
            <div class="default rent">
                <div class="title level1-title-font">房屋金額</div>
                <vue-slider v-model="houseFilter.rent" :min="0" :max="100000" :width="214" :height="2" tooltip="always" :tooltip-placement="'bottom'" :tooltip-formatter="val => numValue(val)" :enableCross="true"/>
            </div>
            <div class="default buildin-type">
                <div class="title level1-title-font">房屋類型</div>
                <rent-select refName="buildingType" selectMsg="所有類型" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="filterBuildingTypeIsEmpty">
                    <ul>
                        <li data-id="1">
                            公寓
                        </li>
                        <li data-id="2">
                            電梯大樓
                        </li>
                        <li data-id="3">
                            透天
                        </li>
                        <li data-id="4">
                            別墅
                        </li>
                    </ul>
                </rent-select>
            </div>
            <div class="default house-type">
                <div class="title level1-title-font">出租類型</div>
                <rent-select refName="houseType" selectMsg="所有類型" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="filterHouseTypeIsEmpty">
                    <ul>
                        <li data-id="1">
                            整層住家
                        </li>
                        <li data-id="2">
                            套房
                        </li>
                        <li data-id="3">
                            雅房
                        </li>
                        
                    </ul>
                </rent-select>
            </div>
            <!-- <div class="default task">
                <div class="title level1-title-font">委託</div>
                <rent-select refName="task" selectMsg="無新增委託" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="filterTaskIsEmpty">
                    <ul>
                        <li data-id="0">
                            無新增委託
                        </li>
                        <li data-id="1">
                            有新增委託
                        </li>
                    </ul>
                </rent-select>
            </div> -->
            <div class="result">
                <div class="view-result" @click="filterClose">
                    查看搜尋結果  {{filterResultTotal}}
                </div>
            </div>
        </div>
        <span class="close" @click="filterClose">
            <img src="../../../../assets/img/icon/cross_white.svg" alt="">
        </span>
    </div>
</template>
<script>
import VueSlider from 'vue-slider-component'
import '@/assets/css/rent.css'
import RentSelect from '@/components/widge/RentSelect.vue';
import VueRangeSlider from 'vue-range-component'
import DatePicker from 'vue2-datepicker';
import { mapGetters } from 'vuex'

export default {
    name: 'houseFilter',
    data () {
        return {
            openState: this.isOpen,
            houseFilter: {
                county: '',
                countyId: '',
                district: '',
                rent: [0, 100000],
                buildingType: '',
                houseType: '',
                task: '',
                status: '',
            },
            isDefault: false,
            filterState: 0,
            address: {
                county: {
                    state: false,
                    msg: '所有縣市'
                },
                district: {
                    state: false,
                    msg: '所有區域'
                },
                road: {
                    state: false,
                    msg: '所有路段'
                }
            },
            filterResultTotal: 0,
            myHeight: (window.innerHeight) + 'px',
            filterTop: null,
        }
    },
    created () {
        this.formatter = value => {
            if( value >= 100000){
                return `$${value}+`
            }else{
                return `$${value}`
            }
        }
    },
    mounted () {
        this.getHashForResultTotal()
        window.addEventListener('scroll', this.handleScroll);

    },
    destroyed () {
        this.$store.dispatch('setHouseMgtFilterDefault')
    },
    props: {
        isOpen: Boolean,
        taskHouseInfo: Object
    },
    watch: {
        isOpen (val) {
            this.openState = val
        },
        houseFilter: {
            handler: function () {
                this.$emit('changeFilter', this.houseFilter)
                this.filterState = 1
            },
            deep: true
        },
        filterTotal: {
            handler: function () {
                this.getHashForResultTotal()
            },
            deep: true
        },
        $route(to, from) {
            // console.log('routeChange')
            this.getHashForResultTotal()
        }
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            this.filterTop = (scrollTop-123) + 'px'
                
        },
        setFilterDefault: function () {
            this.houseFilter = {
                county: '',
                countyId: '',
                district: '',
                rent: [0, 100000],
                buildingType: '',
                houseType: '',
                task: '',
                status: '',
            },
            setTimeout(()=>{
                this.filterState = 0
            },100)
        },
        filterClose: function () {
            this.$emit('filterClose', false);
        },
        getHashForResultTotal: function () {
            let hashTag = decodeURIComponent(this.$route.hash)

            if( hashTag == '#全部' ){
                this.filterResultTotal = this.filterTotal.all
            }else if( hashTag == '#已租' ){
                this.filterResultTotal = this.filterTotal.rented
            }else if( hashTag == '#未租' ){
                this.filterResultTotal = this.filterTotal.rent
            }else{
                this.filterResultTotal = this.filterTotal.all
            }
        },
        getSelectId: function (value) {
            if( value.ref == 'county' ){
                this.address.district.state = true
                this.houseFilter.district = null

                this.houseFilter.county = value.name
                this.houseFilter.countyId = value.id
                this.$store.dispatch('getDistrict',(parseInt(value.id)+1))
            }else if( value.ref == 'district' ){
                this.address.district.state = false
                this.houseFilter.district = value.name
            }else if( value.ref == 'task' ){
                this.houseFilter.task = value.id
            }else if( value.ref == 'buildingType' ){
                this.houseFilter.buildingType = value.id
            }else if( value.ref == 'houseType' ){
                this.houseFilter.houseType = value.id
            }
        },
        numValue: function (val) {
            if( val == '100000' ){
                return '$'+this.toCurrency(val)+'+'
            }else{
                return '$'+this.toCurrency(val)
            }
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // }
    },
    computed: {
        ...mapGetters({
            countyResult: 'COUNTY_RESULT',
            districtsResult: 'DISTRICTS_RESULT',
            filterTotal: 'GET_HOUSE_MGT_FILTER_RESULT_TOTAL',
            filterCountyIsEmpty: 'GET_HOUSE_MGT_FILTER_COUNTY_IS_EMPTY',
            filterDistrictIsEmpty: 'GET_HOUSE_MGT_FILTER_DISTRICT_IS_EMPTY',
            filterHouseTypeIsEmpty: 'GET_HOUSE_MGT_HOUSE_TYPE_IS_EMPTY',
            filterBuildingTypeIsEmpty: 'GET_HOUSE_MGT_BUILDING_TYPE_IS_EMPTY',
            filterTaskIsEmpty: 'GET_HOUSE_MGT_TASK_IS_EMPTY',
        })
    },
    components: {
        RentSelect,
        VueSlider,
        DatePicker,
    }
}
</script>
<style lang="scss" scoped>
    .house-filter{
        position: absolute;
        width: 279px;
        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
        background-color: #ffffff;
        // height: 100%;
        top: -124px;
        right: -350px;
        transition: all 1s ease-in-out;
        z-index: 10;
        .house-filter-wrap{
            position: relative;
            height: 100%;
            .default{
                padding: 20px;
                border-bottom: 1px solid #f0f0f0;
                .title{
                    margin-bottom: 16px;
                }
            }
            .filter-title{
                display: flex;
                align-items: center;
                padding: 24px;
                color: #a8a5a4;
                border-bottom: 1px solid #f0f0f0;
                img{
                    margin-right: 8px;
                }
                .clear-filter{
                    position: absolute;
                    cursor: pointer;
                    font-size: 12px;
                    color: #ff9275;
                    top: 30px;
                    right: 34px;
                }
            }
            .location{
                .group{
                    display: flex;
                    .rent-select:nth-child(1){
                        margin-right: 10px;
                    }
                    .rent-select{
                        width: 75px;
                        height: 18px;
                    }
                }
            }
            .period,
            .rent-date{
                .mx-datepicker {
                    width: 230px;
                    .mx-input-wrapper{
                        .mx-input{
                            height: 46px;
                            border-radius: 4px;
                            border: solid 1px #e0dfde;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 18px;
                        }
                    }
                }
                .mx-datepicker.active{
                    input{
                        border: 1px solid #676362 !important;
                        color: #676362 !important;
                    }
                    i{
                        color: #676362;
                    }
                }
                .mx-datepicker:hover{
                    .mx-input-wrapper{
                        .mx-input{
                            border: 1px solid #676362 !important;
                            color: #676362 !important;
                        }
                    }
                }
            }
            .deposit,
            .rent{
                padding-bottom: 40px;
            }
            .result{
                position: absolute;
                width: 100%;
                height: 76px;
                bottom: 0px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                .view-result{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #ffffff;
                    font-weight: 500;
                    width: 231px;
                    height: 44px;
                    border-radius: 4px;
                    background-color: #ff9275;
                    cursor: pointer;
                }
            }
        }
        .close{
            position: absolute;
            width: 30px;
            height: 44px;
            background-color: #ff9275;
            border-radius: 10px 0 0 10px;
            left: -30px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                cursor: pointer;
            }
        }
    }
    .house-filter.open{
        right: -40px;
    }
    @media screen and (max-width: 1280px) {
        .house-filter.open{
            right: 24px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/houseManagement/HouseFilter.vue